import React from "react";

export default function DashboardFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-slate-200/80 bg-white/80 px-4 py-3 text-center text-xs text-slate-500 backdrop-blur dark:border-slate-800/80 dark:bg-slate-950/80 dark:text-slate-400">
      <span className="font-semibold text-slate-700 dark:text-slate-200">
        MonAppliClub
      </span>{" "}
      © {year} — Dashboard de gestion de club sportif
    </footer>
  );
}